import React, { useCallback } from "react";

import DownloadIcon from "@mui/icons-material/Download";

import { PORTFOLIO_TEMPLATE } from "@src/constants/portfolioPlansBatchTemplate";
import Button from "@src/multiCustodian/components/MUI/Button/Button";
import Text from "@src/sharedComponents/Typography/Text";

const CSVDownloadButton = () => {
  const handleDownload = useCallback(() => {
    const blob = new Blob([PORTFOLIO_TEMPLATE], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "custom_portfolio_example.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, []);

  const handleOnClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.preventDefault();
      handleDownload();
    },
    [handleDownload]
  );

  return (
    <Button
      text={
        <>
          <a style={{ textDecoration: "none" }} onClick={handleOnClick}>
            <Text>Download Template</Text>
          </a>
        </>
      }
      endIcon={<DownloadIcon />}
      variant="text"
      buttonType="primary"
      onClick={handleOnClick}
    />
  );
};

export default CSVDownloadButton;
